"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationsLanguages = exports.TranslationsResources = exports.TranslationResourceKeys = exports.useLibraryI18n = exports.TranslationsProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _i18n = _interopRequireDefault(require("./i18n"));

var _reactI18next = require("react-i18next");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _resourceKeys = require("./resources/resourceKeys");

var _translationsConstants = require("./resources/translationsConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var TranslationsContext = (0, _react.createContext)();
var defaultI18n = _i18n.default;

var TranslationsProvider = function TranslationsProvider(_ref) {
  var _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === void 0 ? defaultI18n : _ref$i18n,
      children = _ref.children,
      lang = _ref.lang;
  (0, _react.useEffect)(function () {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);
  return _react.default.createElement(TranslationsContext.Provider, {
    value: i18n
  }, _react.default.createElement(_reactI18next.I18nextProvider, {
    i18n: i18n
  }, children));
};

exports.TranslationsProvider = TranslationsProvider;

var useLibraryI18n = function useLibraryI18n() {
  var i18n = (0, _react.useContext)(TranslationsProvider);

  if (!i18n) {
    throw new Error('i18n instance not provided');
  }

  return i18n;
};

exports.useLibraryI18n = useLibraryI18n;
var TranslationResourceKeys = _resourceKeys.resourceKeys;
exports.TranslationResourceKeys = TranslationResourceKeys;
var TranslationsResources = _translationsConstants.TRANSLATIONS_RESOURCES;
exports.TranslationsResources = TranslationsResources;
var TranslationsLanguages = _translationsConstants.TRANSLATIONS_LANGUAGES;
exports.TranslationsLanguages = TranslationsLanguages;
TranslationsProvider.propTypes = {
  /** i18n instance for translations */
  i18n: _propTypes.default.object,

  /** Child components to be rendered */
  children: _propTypes.default.node.isRequired,

  /** Language code for translations */
  lang: _propTypes.default.string
};